const secrets = {
    third_party_token_set: {
        token_not_found: 'Token record not found.',
        access_token_expired: 'The access token has expired. Please reconnect your account.',
    },
};
export default Object.freeze(secrets);
